// ref: https://tanstack.com/query/v4/docs/react/reference/useQuery
export const QUERY_STATUS = {
  ENABLED: 'enabled',
  ERROR: 'error',
  DEFAULT: 'loading', // to align our React states with with TanStack docs
  LOADING: 'loading',
  SUCCESS: 'success',
} as const;

export type QueryStatusType = (typeof QUERY_STATUS)[keyof typeof QUERY_STATUS];
